module.exports = __webpack_public_path__ + "img/lg_ring_r_i_null_null@3x.16154378.png";